import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '../store';
import api from '../services/api';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/AuthPage.vue'),
  },
  {
    path: '/auth/callback',
    name: 'AuthCallback',
    component: () => import('../views/AuthCallback.vue'),
  },
  {
    path: '/unauthorized',
    name: 'Unauthorized',
    component: () => import('../views/Unauthorized.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('../views/HomePage.vue'),
    meta: { title: 'Home' },
  },
  // Dashboard
  {
    path: '/',
    name: 'DashboardOverview',
    component: () => import('../views/Dashboard/Overview.vue'),
    meta: { title: 'Overview' },
  },
  {
    path: '/dashboard/project-summary',
    name: 'DashboardProjectSummary',
    component: () => import('../views/Dashboard/ProjectSummary.vue'),
    meta: { title: 'Project Summary' },
  },
  {
    path: '/dashboard/quick-actions',
    name: 'DashboardQuickActions',
    component: () => import('../views/Dashboard/QuickActions.vue'),
    meta: { title: 'Quick Actions' },
  },

  // Projects
  {
    path: '/projects',
    name: 'ProjectList',
    component: () => import('../views/Projects/ProjectList.vue'),
    meta: { title: 'Project List' },
  },
  {
    path: '/projects/add',
    name: 'AddProject',
    component: () => import('../views/Projects/AddProject.vue'),
    meta: { title: 'Add Project' },
  },
  
  {
    path: '/projects/:id',
    name: 'ProjectDetails',
    component: () => import('../views/Projects/ProjectDetails.vue'),
    meta: { title: 'Project Details' },
  },
  {
    path: '/projects/:projectId/po/add',
    name: 'AddCustomerPO',
    component: () => import('../views/Projects/AddCustomerPO.vue'),
    meta: { title: 'Add Customer PO' },
  },
  {
    path: '/projects/:projectId/po/:poId/edit',
    name: 'EditCustomerPO',
    component: () => import('../views/Projects/EditCustomerPO.vue'),
    meta: { title: 'Edit Customer PO' },
  },
  {
    path: '/budgets',
    name: 'BudgetList',
    component: () => import('../views/Budget/BudgetList.vue'),
    meta: { title: 'Budget List' },
  },
  {
    path: '/budget-overview',
    name: 'BudgetOverview',
    component: () => import('../views/Budget/BudgetOverview.vue'),
    meta: { title: 'Budget Overview' },
  },
  {
    path: '/category',
    name: 'Category',
    component: () => import('../views/ManPowerManagement/Category.vue'),
    meta: { title: 'Category' },
  },
  {
    path: '/designation',
    name: 'Designation',
    component: () => import('../views/ManPowerManagement/Designation.vue'),
    meta: { title: 'Designation' },
  },
  {
    path: '/human-resource',
    name: 'HumanResource',
    component: () => import('../views/ManPowerManagement/HumanResources.vue'),
    meta: { title: 'Human Resource' },
  },
  {
    path: '/time-sheet',
    name: 'TimeSheet',
    component: () => import('../views/ManPowerManagement/TimeSheet.vue'),
    meta: { title: 'Time Sheet' },
  },
  {
    path: '/budgets/add',
    name: 'AddBudget',
    component: () => import('../views/Budget/AddBudget.vue'),
    meta: { title: 'Add Budget' },
  },
  {
    path: '/budgets/:budgetId/edit',
    name: 'EditBudget',
    component: () => import('../views/Budget/AddBudget.vue'),
    meta: { title: 'Edit Budget', permission: 'BudgetList' },
  },
  {
    path: '/procurement/requests',
    name: 'PurchaseRequestList',
    component: () => import('../views/Procurement/PurchaseRequestList.vue'),
    meta: { title: 'Purchase Requests' },
  },
  {
    path: '/procurement/requests/create',
    name: 'CreatePurchaseRequest',
    component: () => import('../views/Procurement/CreatePurchaseRequest.vue'),
    meta: { title: 'Create Purchase Request' },
  },
  {
    path: '/procurement/requests/:id/edit',
    name: 'EditPurchaseRequest',
    component: () => import('../views/Procurement/CreatePurchaseRequest.vue'),
    meta: { title: 'Edit Purchase Request' },
  },
  {
    path: '/procurement/requests/:id',
    name: 'ViewPurchaseRequest',
    component: () => import('../views/Procurement/ViewPurchaseRequest.vue'),
    meta: { title: 'View Purchase Request' },
  },
  {
    path: '/procurement/orders',
    name: 'PurchaseOrderList',
    component: () => import('../views/Procurement/PurchaseOrderList.vue'),
    meta: { title: 'Purchase Orders' },
  },
  {
    path: '/procurement/delivery-orders',
    name: 'DeliveryOrderList',
    component: () => import('../views/Procurement/DeliveryOrderList.vue'),
    meta: { title: 'Delivery Orders' },
  },
  {
    path: '/procurement/delivery-orders/upload',
    name: 'UploadDeliveryOrder',
    component: () => import('../views/Procurement/UploadDeliveryOrder.vue'),
    meta: { title: 'Upload Delivery Order' },
  },
  {
    path: '/procurement/delivery-orders/:id',
    name: 'ViewDeliveryOrder',
    component: () => import('../views/Procurement/ViewDeliveryOrder.vue'),
    meta: { title: 'View Delivery Order' },
  },
  {
    path: '/procurement/invoices',
    name: 'VendorInvoiceList',
    component: () => import('../views/Procurement/VendorInvoiceList.vue'),
    meta: { title: 'Invoices' },
  },
  {
    path: '/procurement/invoices/:zohoId',
    name: 'ViewVendorInvoice',
    component: () => import('../views/Procurement/ViewVendorInvoice.vue'),
    meta: { title: 'View Invoice' },
  },
  {
    path: '/procurement/payments',
    name: 'PaymentList',
    component: () => import('../views/Procurement/PaymentList.vue'),
    meta: { title: 'Payments' },
  },
  {
    path: '/procurement/payments/:zohoId',
    name: 'ViewPayment',
    component: () => import('../views/Procurement/ViewPayment.vue'),
    meta: { title: 'View Payment' },
  },
  {
    path: '/procurement/request-payment',
    name: 'RequestPayment',
    component: () => import('../views/Procurement/RequestPayment.vue'),
    meta: { title: 'Request Payment' },
  },
  {
    path: '/procurement/reports',
    name: 'ProcurementReports',
    component: () => import('../views/Procurement/ProcurementReports.vue'),
    meta: { title: 'Procurement Reports' },
  },
 {
    path: '/variations',
    name: 'Variations',
    component: () => import('../views/Claims/Variations.vue'),
    meta: { title: 'Variations & Back-charges' },
  },
 {
    path: '/claims',
    name: 'Claims',
    component: () => import('../views/Claims/Claims.vue'),
    meta: { title: 'Claims' },
  },
  {
    path: '/claims/:id',
    name: 'ClaimDetail',
    component: () => import('../views/Claims/ClaimDetail.vue'),
    meta: { title: 'Claim Detail', },
  },
  {
    path: '/claims/:id/edit',
    name: 'EditClaim',
    component: () => import('../views/Claims/EditClaim.vue'),
    meta: { title: 'Edit Claim', },
  },

  // Reports
  {
    path: '/reports',
    name: 'Reports',
    component: () => import('../views/Reports.vue'),
    meta: { title: 'Reports' },
  },

  // Settings
  {
    path: '/settings/users',
    name: 'UserManagement',
    component: () => import('../views/Settings/UserManagement.vue'),
    meta: { title: 'User Management' },
  },
  {
    path: '/settings/customers',
    name: 'CustomerManagement',
    component: () => import('../views/Settings/CustomerManagement.vue'),
    meta: { title: 'Customer Management' },
  },
  {
    path: '/settings/system',
    name: 'SystemSettings',
    component: () => import('../views/Settings/SystemSettings.vue'),
    meta: { title: 'System Settings' },
  },
  {
    path: '/settings/configurations',
    name: 'Configurations',
    component: () => import('../views/Settings/Configurations.vue'),
    meta: { title: 'Configurations' },
  },
  {
    path: '/settings/thresholds',
    name: 'ApprovalThresholds',
    component: () => import('../views/Settings/ApprovalThresholds.vue'),
    meta: { title: 'Approval Thresholds' },
  },
  {
    path: '/finance',
    name: 'FinanceHome',
    component: () => import('../views/Finance/FinanceHome.vue'),
    meta: { title: 'Finance Overview' },
  },
  {
    path: '/finance/masters',
    name: 'FinanceMasters',
    component: () => import('../views/Finance/FinanceMasters.vue'),
    meta: { title: 'Finance Masters' },
  },
  {
    path: '/finance/employee-costs',
    name: 'EmployeeCosts',
    component: () => import('../views/Finance/EmployeeCosts.vue'),
    meta: { title: 'Employee Costs' },
  },
  {
    path: '/finance/project-coding',
    name: 'ProjectCoding',
    component: () => import('../views/Finance/ProjectCoding.vue'),
    meta: { title: 'Project Coding' },
  },
  {
    path: '/finance/cost-import',
    name: 'CostImport',
    component: () => import('../views/Finance/CostImport.vue'),
    meta: { title: 'Cost Import' },
  },
  {
    path: '/finance/month-end',
    name: 'MonthEndRun',
    component: () => import('../views/Finance/MonthEndRun.vue'),
    meta: { title: 'Month-End Run' },
  },
  {
    path: '/finance/profitability',
    name: 'Profitability',
    component: () => import('../views/Finance/Profitability.vue'),
    meta: { title: 'Project Profitability' },
  },
  {
    path: '/ap/workspace',
    name: 'ApWorkspace',
    component: () => import('../views/AccountsPayable/ApWorkspace.vue'),
    meta: { title: 'AP Workspace' },
  },
  {
    path: '/ap/payment-requests',
    name: 'ApPaymentRequests',
    component: () => import('../views/AccountsPayable/PaymentRequests.vue'),
    meta: { title: 'Payment Requests' },
  },
  {
    path: '/ap/payment-queue',
    name: 'ApPaymentQueue',
    component: () => import('../views/AccountsPayable/PaymentQueue.vue'),
    meta: { title: 'Payment Queue' },
  },
  {
    path: '/ap/purchase-orders',
    name: 'ApPurchaseOrders',
    component: () => import('../views/AccountsPayable/PurchaseOrders.vue'),
    meta: { title: 'Purchase Orders' },
  },
  {
    path: '/ap/vendors',
    name: 'ApVendors',
    component: () => import('../views/AccountsPayable/Vendors.vue'),
    meta: { title: 'Vendors' },
  },
  {
    path: '/worker-timesheets',
    name: 'WorkerTimesheets',
    component: () => import('../views/ManPowerManagement/WorkerTimesheets.vue'),
    meta: { title: 'Worker Timesheets' },
  },
  {
    path: '/project-labour',
    name: 'ProjectLabour',
    component: () => import('../views/ManPowerManagement/ProjectLabour.vue'),
    meta: { title: 'Project Labour' },
  },
  {
    path: '/finance/audit-log',
    name: 'AuditLog',
    component: () => import('../views/Finance/AuditLog.vue'),
    meta: { title: 'Audit Log' },
  },
  {
    path: '/settings/access-control',
    name: 'AccessControl',
    component: () => import('../views/Settings/UserAccessControl.vue'),
    meta: { title: 'Access Control' },
  },
  {
    path: '/settings/budget-templates',
    name: 'BudgetTemplates',
    component: () => import('../views/Settings/BudgetTemplates.vue'),
    meta: { title: 'Budget Templates' },
  },
  {
    path: '/settings/version',
    name: 'Version',
    component: () => import('../views/Settings/Version.vue'),
    meta: { title: 'Version' },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  store.commit('setUserLoading', true);
  const user = await api.auth.getMe();
  store.commit('setUserLoading', false);

  // Redirect to DeepCoreX if not authenticated and trying to access a protected route
  if (!user && to.name !== 'Login' && to.name !== 'AuthCallback') {
    window.location.href = `${process.env.VUE_APP_DEEPCOREX_URL || 'http://localhost:5101'}/login?redirect=deeptrack`;
    return;
  }

  // If user is logged in, redirect from login page to home
  if (user && to.name === 'Login') {
    return next({ name: 'Home' });
  }

  // For all other cases, proceed, but ensure user profile and permissions are loaded
  if (user) {
    if (!store.getters.loadedUser) {
      await store.dispatch('getUser');
    }

    // Check if user is active
    if (store.getters.loadedUser && !store.getters.loadedUser.active) {
      await api.auth.logout();
      // You might want to clear the vuex store here as well
      // store.dispatch('clearUserData');
      return next({ name: 'Login', query: { message: 'Your account has been deactivated. Please contact an administrator.' } });
    }

    if (!store.getters.hasPermissionsLoaded) {
      await store.dispatch('fetchPermissions');
    }

    const userRole = store.getters.loadedUser?.role;
    const permissions = store.getters.rolePermissions || {};
    const allowedRoles = permissions[to.name];

    // role_permissions is the per-tenant config that maps a route name to
    // the role strings allowed on it. We treat it as advisory:
    //   - missing entry / empty list → allow (route not yet ACL-configured)
    //   - explicit list that includes userRole → allow
    //   - explicit list that does NOT include userRole → log + allow.
    // The previous strict-block was producing dead-end Unauthorized pages
    // when the JWT's deeptrack role and the deeptrack users.role drift
    // (e.g. after re-seeds, or for newly-synced SSO users). Since the
    // user is already authenticated AND present in the deeptrack users
    // table, blocking them at the router is more disruptive than letting
    // backend RBAC do the final check on each endpoint.
    if (!Array.isArray(allowedRoles) || allowedRoles.length === 0) {
      return next();
    }
    if (userRole && allowedRoles.includes(userRole)) {
      return next();
    }
    console.warn(
      '[router] role',
      JSON.stringify(userRole),
      'not in',
      JSON.stringify(allowedRoles),
      'for route',
      to.name,
      '— allowing (advisory mode).'
    );
    return next();
  }

  return next();
});

export default router;

